/* eslint no-param-reassign: "error" */
function addClass(el, className) {
  if (el.classList) el.classList.add(className);
}

function removeClass(el, className) {
  if (el.classList) el.classList.remove(className);
}

const eventHandler = () => {
  const elements = document.querySelectorAll('.js-text-field-input');
  Array.prototype.forEach.call(elements, el => {
    el.addEventListener('focus', () => {
      addClass(el.parentElement, 'active');
    });

    el.addEventListener('focusout', () => {
      if (!el.value) {
        removeClass(el.parentElement, 'active');
      } else {
        const id = el.getAttribute('id');
        const elementsWithId = document.querySelectorAll(`#${id}`);
        Array.prototype.forEach.call(elementsWithId, element => {
          addClass(element, 'active');
        });
      }
    });
  });
};

const textField = async () => eventHandler();

export default textField;
